import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsPaymentDetailsPaymentInfoActions = createActionGroup(
  {
    source: 'Hosted Payments Payment Details Payment Info',

    events: {
      'Validate Account Number Success': emptyProps(),

      'Validate Account Number Error': props<{
        accountNumberInvalid: boolean;
      }>(),
    },
  },
);
